import { useQuery } from '@tanstack/react-query';
import { api } from '../api-client.config';
import { CompetitionType } from 'src/types/domain.types';
import { queryConfig } from '../react-query.config';

const getCompetitions = (): Promise<{ competitions: CompetitionType[] }> =>
  api.get('/competitions');

export const useGetCompetitionsQuery = () => {
  return useQuery({
    ...queryConfig,
    queryKey: ['competitions'],
    queryFn: () => getCompetitions(),
    select: (data: { competitions: CompetitionType[] }) => data.competitions,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchInterval: 1000 * 60,
  });
};
